import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Title from "components/shared/stays/Title";
import Photo from "components/shared/stays/Photo";
import styles from "components/giveaways/SideBySideRow.module.scss";

export default function SideBySideRow({
  className = null,
  children,
  photo,
  headline = null,
  isReversed = false,
  isQuote = false,
  quoteAttribution = null,
}) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn(
        styles.component,
        className,
        isReversed ? styles.reversed : ""
      )}
    >
      <div className={styles.content}>
        {!isQuote && headline ? (
          <Title size={4} tag="h2" font="cushing">
            {headline}
          </Title>
        ) : (
          <span className={styles.quote}>&ldquo;</span>
        )}
        {children}
        {isQuote && quoteAttribution && (
          <span className={styles.attribution}>&mdash;{quoteAttribution}</span>
        )}
      </div>
      <div className={styles.image} ref={imgWrapperRef}>
        <Photo
          imageBlurSrc={photo.blurDataURL}
          placeholder
          src={photo.src}
          layout="fill"
          objectFit="cover"
          containerWidth={imgWidths[0]}
          alt={headline || ""}
        />
      </div>
    </div>
  );
}

SideBySideRow.propTypes = {
  children: PropTypes.node.isRequired,
  photo: PropTypes.shape({
    src: PropTypes.string,
    blurDataURL: PropTypes.string,
  }).isRequired,
  className: PropTypes.node,
  headline: PropTypes.string,
  isReversed: PropTypes.bool,
  isQuote: PropTypes.bool,
  quoteAttribution: PropTypes.string,
};
